import {
  Box,
  BoxProps,
  ContextMenu,
  ContextMenuItem,
  ContextMenuList,
} from '@modusign/design-system';
import noop from 'lodash/fp/noop';

interface TextFieldAutoSuggestionListProps extends BoxProps<'div'> {
  isOpen: boolean;
  alignCenter?: boolean;
}

function TextFieldAutoSuggestionList({
  isOpen,
  children,
  alignCenter,
  ...props
}: TextFieldAutoSuggestionListProps) {
  return (
    <Box {...props} height="100%" left={0} position="absolute" top={0} width="100%">
      <ContextMenu isOpen={isOpen} onOpenChange={noop}>
        <ContextMenuList
          maxWidth="100%"
          minWidth="160px"
          position="absolute"
          style={{ transform: `translateX(${alignCenter ? '-50' : '0'}%) translateY(10%)` }}
        >
          {children}
        </ContextMenuList>
      </ContextMenu>
    </Box>
  );
}

interface TextFieldAutoSuggestionItemProps extends BoxProps<'div'> {
  highlighted: boolean;
  children: React.ReactElement;
}

function TextFieldAutoSuggestionItem({
  children,
  highlighted,
  ...props
}: TextFieldAutoSuggestionItemProps) {
  return (
    <Box {...props} width="100%">
      <ContextMenuItem
        backgroundColor={highlighted ? 'menuBackgroundNeutralDark' : 'menuBackgroundNeutralBase'}
        height="32px"
        sx={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
        width="100%"
      >
        {children}
      </ContextMenuItem>
    </Box>
  );
}

const TextFieldAutoSuggestion = {
  List: TextFieldAutoSuggestionList,
  Item: TextFieldAutoSuggestionItem,
};
export default TextFieldAutoSuggestion;
